import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'

import {
  ScrollTrigger
} from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import Observer from '../components/observer';


class Animation extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')

    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
      img: null,
      trigger: null,
      cover: null

    }

  }

  mount() {

    // this.observer = new Observer({
    //   rootMargin: '-2.9% 0% -97% 0%',
    //   callback: (visible, target, entry) => {

    //     if (visible) {
    //       document.body.classList.add(`menu-color-${target.dataset.color}`)
    //     } else {
    //       document.body.classList.remove(`menu-color-${target.dataset.color}`)
    //     }
    //   }
    // });
    // this.observer.add('[data-color]');

    this.sections = new Observer({
        rootMargin: '-1%'
    })

 
    this.sections.add('.section__decor')

     this.locations = new Observer({
       rootMargin: '40% -1% -1% -1%'
     })
     this.locations.add('.reservations__col')

      this.menu = new Observer({
        rootMargin: '40% -1% -1% -1%'
      })
      this.menu.add('.menu__location')


       this.tease = new Observer({
         rootMargin: '40% -1% -1% -1%'
       })
       this.tease.add('.tease')


       this.invanim = new Observer({
         rootMargin: '10% 0% 10% 0%'
       })
       this.invanim.add('.invanim')
    

    // ScrollTrigger.create({
    //   trigger: this.ref.cover,
    //   start: "top top",
    //   id: `id70`,
    //   onEnter: (self) => {
    //     $('body').addClass(`has-nav`)
    //   },
    //   onLeaveBack: (self) => {
    //     $('body').removeClass(`has-nav`)
    //   }
    // });


  }



  unmount() {


  //  this.observer.disconnect()
    this.sections.disconnect()
    this.locations.disconnect()
    this.menu.disconnect()
    this.tease.disconnect()
    this.invanim.disconnect()

   // ScrollTrigger.getById('id70').kill();

  }


}

module.exports = Animation